import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Select, Tooltip, Checkbox } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";
import puzzle from "../../../../assets/img/bl.svg";
import CustomSwitchButtons, {
  FlagSwitchButtons,
  TackleRadioButtons,
} from "../CustomSwitchButtons.js";
import { Link, useNavigate } from "react-router-dom";
import positiveImpact from "../../../../assets/img/positiveImpact.svg";
import positiveImpactAction from "../../../../assets/img/Action.svg";
import consumable from "../../../../assets/img/consumable.svg";
import check from "../../../../assets/img/check.png";

function TargetModal({
  state,
  dispatch,
  close,
  update,
  item,
  school_id,
  loadAllPlayerList,
  schoolCustomStats,
  getStats,
  play,
  handleUpdatePlay,
  updateInputGrade,
  updateGrade,
  handleExpandToggle,
  handleQuickUpdate,
  showPassPro,
  setShowPassPro,
  playerList,
  handleMultipleQuickUpdate,
}) {
  const [modalWidth, setModalWidth] = useState(425);
  let history = useNavigate();
  const [customStats, setCustomStats] = useState([]);
  const [customStatValues, setCustomStatValues] = useState(
    JSON.parse(item.custom_stats || "[]")
  );
  const [storage, setStorage] = useState({});

  const handleSaveCustomStat = (stat, value) => {
    const _customStatValues = { ...customStatValues };
    _customStatValues[stat.label] = value;
    setCustomStatValues(_customStatValues);

    updateGrade("custom_stats", JSON.stringify(_customStatValues));
  };

  const handleCStats = () => {
    setCustomStatValues(JSON.parse(item.custom_stats || "{}"));
    const _customStats = schoolCustomStats?.filter((stat) => stat.odk == "o");
    setCustomStats(
      _customStats?.length
        ? _customStats?.filter((stat) => stat.index == "2")
        : []
    );
  };
  useEffect(handleCStats, [item.custom_stats, schoolCustomStats]);
  useEffect(handleCStats, []);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setModalWidth(352);
    } else {
      setModalWidth(425);
    }
  }, [window.innerWidth]);

  return (
    state.ol && (
      <div className="w-full text-[12px] flex justify-between text-[#0F1A24]">
      <div
        style={{ border: "1px solid #F3F5F7" }}
        className="w-[49%]"
      >
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[35%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Flag</span>
          </div>{" "}
          <div className="px-2 py-2 w-[40%] turn-over actor flex items-center justify-center">
            <FlagSwitchButtons
              item={item}
              defaultState={item?.penalties}
              handleQuickUpdate={handleQuickUpdate}
              title="penalties"
            />
          </div>
        </div>
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[35%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Pancake</span>
          </div>{" "}
          <div className="px-2 py-2 w-[40%] turn-over actor flex items-center justify-center">
            <CustomSwitchButtons
              item={item}
              defaultState={item?.pancakes}
              handleQuickUpdate={handleQuickUpdate}
              title="pancakes"
            />
          </div>
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[35%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Pass Protection</span>
          </div>{" "}
          <div className="px-2 py-2 w-[40%] turn-over actor flex items-center justify-center">
            {play?.play_type?.toLowerCase() === "run" || !showPassPro ? (
              <div className="actor flex w-full items-center justify-center">
                ----
              </div>
            ) : (
              <TackleRadioButtons
                item={item}
                defaultState={item?.pass_pro_sacks}
                handleQuickUpdate={(a, b, c, d, e, f) => {
                  if (d === 2) {
                    setShowPassPro(false);
                    const ids = playerList
                      .filter(
                        (grade) =>
                          Object.keys(grade).includes("assignment_executed") &&
                          grade.pass_pro_sacks !== 2
                      )
                      .map((grade) => ({
                        id: grade?.id,
                        athlete: grade.athlete,
                      }));

                    handleMultipleQuickUpdate(ids, c, d, e, f);
                  } else {
                    handleQuickUpdate(a, b, c, d, e, f);
                  }
                }}
                title="pass_pro_sacks"
                imageTwo={consumable}
                imageThree={check}
                tooltipTitle="Lost"
                tooltipTitleTwo="RPO"
                tooltipTitleThree="Won"
                color="grey"
                colorThree="onefive-active"
              />
            )}
          </div>
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[35%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Positive Impact</span>
          </div>{" "}
          <div className="px-2 py-2 w-[40%] turn-over actor flex items-center justify-center">
            <div
              onClick={() => {
                if (item?.disabled) return;
                handleQuickUpdate(
                  item.id,
                  item.athlete,
                  "positive_impact",
                  !item?.positive_impact ? 1 : 0
                );
              }}
              className="flex w-[100%] items-center justify-center"
            >
              {item?.positive_impact == 1 && (
                <img
                  src={positiveImpactAction}
                  className="w-[60%] max-w-[35px] cursor-pointer"
                />
              )}
              {(item?.positive_impact === 0 || !item?.positive_impact) && (
                <img
                  src={positiveImpact}
                  className="w-[60%] max-w-[35px] cursor-pointer"
                />
              )}
            </div>
          </div>
        </div>
      </div>
        <div className="w-[49%] px-2">
          <div className="flex items-center text-md mb-2">
            <button
              onClick={() => handleExpandToggle(item, "ol-modal")}
              className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
            >
              <img src={floppyDiskImg} className="w-6" />
              <span className="ml-2">Save and close</span>
            </button>
          </div>
          <span className="font-inter text-[14px] font-bold">
            Custom Stats{" "}
          </span>
          <div
            style={{ border: "1px solid #F3F5F7" }}
            className="mt-1 text-[12px] text-[#0F1A24] mb-2"
          >
            {customStats?.map((stat) => (
              <div
                key={stat.label}
                className="flex items-center"
                style={{ borderBottom: "1px solid #F3F5F7" }}
              >
                <div
                  className="w-[70%] px-2 py-2 font-bold"
                  style={{ borderRight: "1px solid #F3F5F7" }}
                >
                  <span>{stat.label}</span>
                </div>{" "}
                <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
                  {stat.input_type == "numeric" ? (
                    <Input
                      defaultValue={
                        JSON.parse(item.custom_stats || "{}")[stat.label]
                      }
                      onChange={(e) =>
                        handleSaveCustomStat(stat, e.target.value)
                      }
                      size="small"
                      className="w-[40%] p-1"
                    />
                  ) : (
                    <Switch
                      defaultChecked={
                        JSON.parse(item.custom_stats || "{}")[stat.label]
                      }
                      onChange={(e) => handleSaveCustomStat(stat, e ? 1 : 0)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
          <span className="text-[#8698A9]">
            Edit custom stats in your{" "}
            <span onClick={() => history("/add-stats")} className="underline cursor-pointer">
              Admin Settings
            </span>
          </span>
        </div>
      </div>
    )
  );
}

export default TargetModal;
